module.exports = __webpack_public_path__ + "assets/img/google.546444f3.png";